<script setup lang="ts">
import { computed } from 'vue';
import { calendarProps, enUS } from 'naive-ui';
import { gaiaAccent, gaiaFontWeight, gaiaNeutral } from '../themes/tokens';

const props = defineProps(calendarProps);

// naive reads the first weekday from the DatePicker locale, and enUS starts on
// Sunday. Contract deadlines are planned in working weeks, so Monday leads.
const mondayFirstLocale = {
  ...enUS,
  DatePicker: { ...enUS.DatePicker, firstDayOfWeek: 0 as const },
};

// Caller-supplied theme-overrides win (spread last).
const mergedThemeOverrides = computed(() => ({
  borderColor: gaiaNeutral.borderCard,
  textColor: gaiaNeutral.text,
  titleTextColor: gaiaNeutral.ink,
  titleFontWeight: String(gaiaFontWeight.regular),
  dayTextColor: gaiaNeutral.textSubtle,
  cellColor: gaiaNeutral.surface,
  cellColorHover: gaiaNeutral.surfaceSoft,
  dateColorCurrent: gaiaAccent.base,
  dateTextColorCurrent: gaiaNeutral.surface,
  barColor: 'transparent',
  ...props.themeOverrides,
}));
</script>

<template>
  <!-- Themed n-calendar — a month grid with prev / Today / next. Cells take
       their content from the default slot; the selection bar is hidden, since
       a Gaia calendar shows dates rather than picking one. -->
  <n-config-provider abstract :locale="mondayFirstLocale">
    <n-calendar v-bind="props" :theme-overrides="mergedThemeOverrides">
      <template v-if="$slots.header" #header="slotProps"
        ><slot name="header" v-bind="slotProps"
      /></template>
      <template #default="slotProps"><slot v-bind="slotProps" /></template>
    </n-calendar>
  </n-config-provider>
</template>
